import AppDispatcher from "../dispatcher/AppDispatcher"
import Constants from "../constants/Constants"
import 'whatwg-fetch'
import config from 'react-global-configuration';
import cookie from 'react-cookies'


var MemberActions = {


  getDetail(token){

    fetch(config.get("API_PATH") + config.get("API_USER_DETAIL").url, {
      method: config.get("API_USER_DETAIL").method,
      headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify({
       access_token: token,
       data:{
         }
      })

    }).then(function(response) {
      if(response.status == 200){
        return response.json()
      }else if(response.status == 401){
        return null
      }else{
        return response.status
      }
    }).then(function(data) {

      if(data != null && data.status && data.status == 1){

        AppDispatcher.dispatch({
          actionType: Constants.MEMBER_GET_DETAIL,
          detail:data.user
        })
      }else if(data == null){
        window.location = "/login"
      }else{

        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          code:data
        })
      }
    })


  },

  getPaidList(token){
    console.log(token)
    fetch(config.get("API_PATH") + config.get("API_USER_PAYMENT").url, {
      method: config.get("API_USER_PAYMENT").method,
      headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify({
       access_token: token,
       data:{
         }
      })

    }).then(function(response) {
      if(response.status == 200){
        return response.json()
      }else if(response.status == 401){
        return null
      }else{
        return response.status
      }
    }).then(function(data) {

      if(data != null && data.status && data.status == 1){

        AppDispatcher.dispatch({
          actionType: Constants.MEMBER_GET_PAID_LIST,
          list:data.payments
        })
      }else if(data == null){
        window.location = "/club/login"
      }else{

        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          code:data
        })
      }
    })


  },

  getList(token){
    //console.log(token)
    fetch(config.get("API_PATH") + config.get("API_USER_DETAIL").url, {
      method: "GET",
      headers: {
       'Authorization': 'Bearer ' + token
      }
    }).then(function(response) {
      console.log(response)
      if(response.status == 200){
        return response.json()
      }else if(response.status == 401){
        return null
      }else{
        return response.status
      }
    }).then(function(data) {

      if(data != null && data.status && data.status == 1){

        AppDispatcher.dispatch({
          actionType: Constants.MEMBER_GET_LIST,
          list:data.users
        })
      }else if(data == null){
        window.location = "/club/login"
      }else{

        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          code:data
        })
      }
    }).catch(function(error) {
        console.log("error:" + error);
    });


  },


  updatePicture(token,picture, refresh_token){

    const  request_data = {
      "picture":picture
    }


    fetch(config.get("API_PATH") + config.get("API_USER_PICTURE_UPDATE")  , {
      method: "PATCH",
      headers: {
       'Content-Type': 'application/json',
       'Authorization': 'Bearer ' + token,
     },
     body: JSON.stringify(request_data)

    }).then(function(response) {

      if(response.status == 200){
        return response.json()
      }else if(response.status == 401){
        return null
      }else{
        return response.status
      }
    }).then(function(data) {


      if(data != null){
        AppDispatcher.dispatch({
          actionType: Constants.AUTH, // 誰に
          is_auth: true,
          token: token,
          refresh_token: refresh_token
        })

      }else if(data == null){
        window.location = "/club/login"
      }else{

        AppDispatcher.dispatch({
          actionType: Constants.API_ERROR,
          code:data
        })
      }
    })


  }






}

export default MemberActions



// WEBPACK FOOTER //
// ./src/actions/MemberActions.js